import React, { memo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, Typography, Button, IconButton } from "@mui/material";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import LanguageIcon from "@mui/icons-material/Language";
import classNames from "classnames";
import { withStyles } from "@mui/styles";
import MenuIcon from "@mui/icons-material/Menu";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import NavigationDrawer from "../../../shared/components/NavigationDrawer";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import en from "../../images/ic_flag_en.svg";
import es from "../../images/ic_flag_es.jpeg";
import Cookies from "js-cookie";
import { useMediaQuery } from "@mui/material";

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 5 : 0,
  });
}

const styles = (theme) => ({
  root: {
    bgColor: "rgba(255, 255, 255, 0.8) !important",
  },

  navbarBrand: {
    textDecoration: "none !important",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    lineHeight: "0",
    position: "relative",
    fontWeight: "700",
    fontSize: "large",
    color: "#000",
  },

  brand: {
    width: "11rem",
    color: theme.palette.common.white,
    [`@media (max-width:  600px)`]: {
      width: "7rem",
      top: "0px",
    },
  },
  nuevoHeight: {
    height: "75px",
    bgColor: "rgba(255, 255, 255, 0.8) !important",
    [`@media (max-width:  600px)`]: {
      height: "75px !important",
      justifyContent: "space-between !important",
    },
    [`@media (min-width:  1280px)`]: {
      height: "75px !important",
      paddingTop: "0px",
    },
  },
  toolbar: {
    display: "flex",
    position: "relative",
    justifyContent: "space-between",
    marginLeft: "auto",
    marginRight: "auto",
    transition:
      "height 250ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, background-color 250ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    color: "rgb(33, 43, 54)",
    height: "120px",
    minWidth: "1200px",
    alignItems: "center",
    [`@media (max-width:  600px)`]: {
      minWidth: "100%",
      justifyContent: "space-between !important",
      height: "75px",
    },
    [`@media (max-width:  1280px)`]: {
      height: "125px",
    },
  },

  marginL: {
    marginLeft: "15px",
  },

  btnIdiomas: {
    fontSize: "1.5rem  !important",
    minWidth: "0px !important",
    borderRadius: "50% !important",
    overflow: "visible",
    color: "#637381 !important",
    transition:
      "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
  },

  menuButtonText: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
    fontFamily: "Lato",
    color: "#1d2b4f",
  },
  brandText: {
    textDecoration: "none !important",
    whiteSpace: "nowrap",
  },

  viajesBttn: {
    [theme.breakpoints.down("xs")]: {
      top: "5px",
    },
  },
  noDecoration: {
    textDecoration: "none !important",
    fontSize: "1rem",
    color: "#1d2b4f",
  },
  listLink: {
    textDecoration: "none !important",
    color: "black",
    fontFamily: "Lato",
  },
  boxShadow: {
    boxShadow: "0 0.0625rem 0.375rem 0 rgb(0 0 0 / 30%) !important",
  },
});

function NavBar(props) {
  const {
    classes,
    openContactoDialog,
    handleMobileDrawerOpen,
    handleMobileDrawerClose,
    mobileDrawerOpen,
    selectedTab,
    handleScrollClick,
    quienes,
    servicios,
    inicio,
    anuncios,
    setIdioma,
    idioma,
    messages,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const isShort = useMediaQuery("(max-width: 900px)");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  const menuItems = [
    {
      link: "/",
      name: messages.inicio,
      icon: <BookmarkIcon className="text-white" />,
      part: inicio,
    },

    {
      link: "/",
      name: messages.tigie,
      icon: <HowToRegIcon className="text-white" />,
      part: servicios,
    },

    {
      link: "/",
      name: messages.nuestros_productos,
      icon: <HowToRegIcon className="text-white" />,
      part: anuncios,
    },

    {
      link: "/",
      name: messages.faq,
      icon: <HowToRegIcon className="text-white" />,
      part: quienes,
    },

    /*     {
      url:
        "http://sc9.transplog.com:8080/scriptcase/app/gestion_global/sec_Login/",
      name: "Login",
      icon: <HowToRegIcon className="text-white" />,
    }, */

    {
      name: messages.contactanos,
      onClick: openContactoDialog,
      icon: <LockOpenIcon className="text-white" />,
    },
  ];
  return (
    <div className={classNames(classes.root)}>
      <ElevationScroll {...props}>
        <AppBar color={"terceary"} position={isShort ? "sticky" : "fixed"}>
          <Toolbar
            className={classNames(
              classes.toolbar,
              trigger ? classes.nuevoHeight : ""
            )}
          >
            <div>
              <Link className={classes.navbarBrand} to="/">
                <img
                  className={classes.brand}
                  src={`${process.env.PUBLIC_URL}/images/logo.png`}
                  alt="Pedimento empresarial"
                />
              </Link>
            </div>
            <div>
              <Box
                component="span"
                sx={{ p: 2, display: { xs: "none", md: "inline" } }}
              >
                <Button
                  className={classes.btnIdiomas}
                  id="basic-button"
                  color="secondary"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <LanguageIcon />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      setIdioma("es-MX");
                      Cookies.set("idioma", "es-MX");
                    }}
                    sx={{ padding: "4px 8px" }}
                    selected={idioma === "es-MX"}
                  >
                    <Chip
                      avatar={<Avatar alt="Español" src={es} />}
                      label={messages.spanish}
                      variant="outlined"
                      sx={{ width: "100%" }}
                    />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      setIdioma("en-US");
                      Cookies.set("idioma", "en-US");
                    }}
                    sx={{ padding: "4px 8px" }}
                    selected={idioma === "en-US"}
                  >
                    <Chip
                      avatar={<Avatar alt="Inglés" src={en} />}
                      label={messages.english}
                      variant="outlined"
                      sx={{ width: "100%", justifyContent: "left" }}
                    />
                  </MenuItem>
                </Menu>
              </Box>
              <Box sx={{ flexGrow: 1, display: { xs: "none", md: "inline" } }}>
                {menuItems.map((element) => {
                  if (element.link) {
                    return (
                      <Button
                        key={element.name}
                        size="large"
                        classes={{ text: classes.menuButtonText }}
                        color="secondary"
                        onClick={() => {
                          handleScrollClick(element.part);
                        }}
                      >
                        {element.name}
                      </Button>
                    );
                  }
                  if (element.url) {
                    return (
                      <a
                        target="_blank"
                        key={element.name}
                        className={`${classes.noDecoration} ${classes.marginL}`}
                        href={element.url}
                        rel="noopener noreferrer"
                      >
                        <Button
                          size="large"
                          classes={{
                            text: classes.menuButtonText,
                          }}
                          color="secondary"
                          variant="contained"
                        >
                          {element.name}
                        </Button>
                      </a>
                    );
                  }
                  return (
                    <Link
                      key={element.name}
                      className={`${classes.noDecoration} ${classes.marginL}`}
                      onClick={element.onClick}
                      to=""
                    >
                      <Button
                        size="large"
                        classes={{
                          text: classes.menuButtonText,
                        }}
                        color="secondary"
                        variant="outlined"
                      >
                        {element.name}
                      </Button>
                    </Link>
                  );
                })}
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  display: { xs: "inline", md: "none" },
                }}
              >
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  onClick={handleMobileDrawerOpen}
                  color="secondary"
                >
                  <MenuIcon color="secondary" />
                </IconButton>
              </Box>
            </div>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <NavigationDrawer
        menuItems={menuItems}
        anchor="right"
        open={mobileDrawerOpen}
        selectedItem={selectedTab}
        onClose={handleMobileDrawerClose}
        handleScrollClick={handleScrollClick}
      />
    </div>
  );
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleScrollClick: PropTypes.func.isRequired,
  handleMobileDrawerOpen: PropTypes.func,
  handleMobileDrawerClose: PropTypes.func,
  mobileDrawerOpen: PropTypes.bool,
  selectedTab: PropTypes.string,
  openRegisterDialog: PropTypes.func.isRequired,
  openLoginDialog: PropTypes.func.isRequired,
  openContactoDialog: PropTypes.func.isRequired,
  quienes: PropTypes.object.isRequired,
  inicio: PropTypes.object.isRequired,
  servicios: PropTypes.object.isRequired,
  anuncios: PropTypes.object.isRequired,
  messages: PropTypes.object.isRequired,
  setIdioma: PropTypes.func.isRequired,
  idioma: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(memo(NavBar));
